import { render, staticRenderFns } from "./JobPopupCard.vue?vue&type=template&id=65db1bea&scoped=true&"
import script from "./JobPopupCard.vue?vue&type=script&lang=js&"
export * from "./JobPopupCard.vue?vue&type=script&lang=js&"
import style0 from "./JobPopupCard.vue?vue&type=style&index=0&id=65db1bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db1bea",
  null
  
)

export default component.exports